import { PromptItemInfos } from "./PromptItemInfos";



/// <summary>
/// 查询结果信息
/// </summary>
export class QueryResultInfo {

	constructor() {
		this.count = null;
		this.keyWord = null;
		this.mclayer = null;
		//提示信息
		this.prompt = null;
		this.resultType = -1;
	}


	/**
		 *设置结果的基本信息（此方法不对外开放，仅内部调用） 
		 * @param jsonObj
		 */
	SetResultBasicInfo(jsonObj) {
		if (jsonObj == null) return;

		this.count = jsonObj.count;
		this.keyWord = jsonObj.keyWord;
		this.mclayer = jsonObj.mclayer;
		this.prompt = PromptItemInfos.GetPromptItems(jsonObj.prompt);
		this.resultType = jsonObj.resultType;
	}




}//end QueryResultInfo

